import axios from 'axios'
export const API_HOST = process.env.VUE_APP_API_URL;

const instance = axios.create()

instance.interceptors.response.use(response => {
    return response;
  }, error => {
  if (error.response.status === 401) {
    catchError(error);
  }
  if (error.response.status === 403) {
    catchError(error);
  }

  throw error;
});

export const AXIOS_INSTANCE = instance;

function unauthenticated() {
  window.localStorage.removeItem('token');
  window.location = '/';
}

export function catchError(err) {
	if (err.response.status === 401) {
			unauthenticated();
	}
	if (err.response.status == 403) {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let kit = url.searchParams.get("kit_number");
    if(!!kit && kit != '') window.location = `/perfil?kit_number=${kit}`;
    else window.location = '/perfil';
			
	}
	console.log(err.response);
	return err.response;
}



// WEBPACK FOOTER //
// ./src/services/api.js